export const ACTIVITY_TYPES = {
  GALLERY_EMAIL_REFERER: 'Thunderbolt.GalleryEmailReferer',
  PERFORM_GALLERY_SEARCH: 'Thunderbolt.PerformGallerySearch',
  WRENCH_PRODUCT_VIEW: 'Thunderbolt.WrenchProductView',
};
